/*!
 * www.sangetsu.co.jp - monostory.min.js
 * @generated Tue Dec 17 2019 09:38:45 GMT+0900 (東京 (標準時))
 */
'use strict';

/* !
 * jQuery showroom v1.0.0
 * Copyright 2016, Connecty Inc.
 */
(function ($, SANGETSU, cssua) {
	var a = 'is-active';
	var v = 'is-visible';

	// メインビジュアル 高さ指定
	$(window).on('resize load', function () {
		if (SANGETSU.va.window.width > SANGETSU.va.device.sp) {
			var winH = $(window).height() - 80;
			$('.monostory-main').css('height', winH);
		}
	});

	// アニメーション
	window.onload = function () {
		// $('.monostory-main .js-titleAnimation').addClass(a).delay(1000).queue(function(next){
		// 	$('.monostory-main .js-titleAnimation').addClass('show').delay(600).queue(function(){
		// 		$('.monostory-main .js-titleAnimation').addClass('done');
		// 	});
		// 	next();
		// });

		// h2 inview
		var inviewTitle = $('.monostory-head01.js-titleAnimation');
		var inviewItem = $('.js-inviewItem');

		inviewTitle.each(function () {
			$(this).on('inview', function (event, isInView, visiblePartX, visiblePartY) {
				$(this).addClass('show').delay(600).queue(function () {
					$(this).addClass('done');
				});
			});
		});
		inviewItem.each(function () {
			$(this).on('inview', function (event, isInView, visiblePartX, visiblePartY) {
				$(this).addClass(v);
			});
		});
	};

	// スライド
	$('.monostory-slide').owlCarousel({
		items: 1,
		slideSpeed: 300,
		paginationSpeed: 400,
		nav: true,
		navText: ['<img src="/common/images/arrow_top.png">', '<img src="/common/images/arrow_top.png">']
	});
	// スライド（自動）
	$('.monostory-slide_auto').owlCarousel({
		items: 1,
		loop: true,
		dots: true,
		dotsSpeed: 1200,
		autoplaySpeed: 1200,
		autoplay: true,
		autoplayTimeout: 3500,
		navText: ['<img src="/common/images/arrow_top.png">', '<img src="/common/images/arrow_top.png">']
	});
})(window.jQuery, window.SANGETSU, window.cssua);